import React, { useState, useEffect } from 'react';
import { API_DOMAIN } from './globals'; // Import the global domain name

function Exposure() {

    const [myExposure, setExposure] = useState([]);  // Store the API response
    const [loading, setLoading] = useState(true);  // Loading state
    const [error, setError] = useState(null);  // Error state

    const formatDateWithDashes = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };
    ;

    const ResetExposure = () => {
        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        // Create an object to pass parameters to the GET request
        const params = {
            ut: param1,
            un: param2,
        };

        const queryString = new URLSearchParams(params).toString();
        const url = `${API_DOMAIN}/api/Client/ResetExposure.php?${queryString}`;

        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status == "Error") {
                    sessionStorage.setItem("LogoutMsg", data.Message)
                    window.location = '/';
                } else {
                    //console.log(data.data);
                    document.getElementById("TotalCoins").innerHTML = data.TotalCoins - data.UsedCoins;
                    document.getElementById("UsedCoins").innerHTML = data.UsedCoins;
                    //document.getElementById("RCoins").innerHTML = res.RemCoins;

                    document.getElementById("TotalCoinsMob").innerHTML = data.TotalCoins - data.UsedCoins;
                    document.getElementById("UsedCoinsMob").innerHTML = data.UsedCoins;

                    sessionStorage.setItem('Coins', data.TotalCoins);
                    sessionStorage.setItem('Exposure', data.UsedCoins);

                    let Response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                        <div data-reactroot="" class="message-content success">
                            <i class="component-icon-wrap icon-success"></i>
                            <p style="font-size:14px;">Exposure Reset Successfully</p>
                        </div>
                    </div>`;

                    document.getElementById("BetResponse").innerHTML = Response;

                    setTimeout(function () {
                        document.getElementById("BetResponse").innerHTML = "";
                    }, 3000);
                }
                setLoading(false); // Set loading to false
            })
            .catch(err => {
                setError(err); // Save any error to the state
                setLoading(false); // Set loading to false
            });
    };

    useEffect(() => {
        // Define your parameters
        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        // Create an object to pass parameters to the GET request
        const params = {
            ut: param1,
            un: param2,
        };

        const queryString = new URLSearchParams(params).toString();
        const url = `${API_DOMAIN}/api/Client/getMyExposure.php?${queryString}`;

        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status == "Error") {
                    sessionStorage.setItem("LogoutMsg", data.Message)
                    window.location = '/';
                } else {
                    //console.log(data.data);
                    setExposure(Array.isArray(data.result) ? data.result : []);
                }
                setLoading(false); // Set loading to false
            })
            .catch(err => {
                setError(err); // Save any error to the state
                setLoading(false); // Set loading to false
            });

    }, []);  // Empty dependency array ensures this runs only once when the component mounts

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <>
            <section className="accountste match-content">
                <div className="table_tittle" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white' }}>
                    Exposure

                    {/* <span className="blink" style={{ height: '30px', textAlign: 'center', color: 'white', background: 'green', width: '60px', top: '17px', left: '90px' }}>
                        <span className="blink-txt" style={{ fontSize: '14px', top: '-5px' }} onClick={ResetExposure}>Reset</span>
                    </span> */}

                </div>
                <div className="col-md-12"></div>
                <div id="divLoading"></div>
                <div className="appendAjaxTbl">
                    <div className="table-responsive sports-tabel">
                        <table className="table table-bordered table-hover" id="datatabless">
                            <thead>
                                <tr style={{ background: '#000',color:'white'}}>
                                    <th className="">S.No. </th>
                                    <th className="">Market </th>
                                    <th className="">Runner </th>
                                    <th className="rrig text-right">Stake </th>
                                    <th className="rrig text-right">Rate</th>
                                    <th className="rrig text-center">Mode </th>
                                    <th className="rrig text-center">Run </th>
                                    <th className="rrig">Time </th>
                                </tr>
                            </thead>
                            <tbody>
                                {myExposure.map((row, index) => (
                                    <tr key={index}>
                                        <td style={{color:'black'}}>{index + 1}</td>
                                        <td className=" " style={{color:'black'}}>{row.MatchName}</td>
                                        <td className=" " style={{color:'black'}}>{row.Description}</td>
                                        <td className="text-right" style={{ fontWeight: 'bold',color:'black' }}>{row.Amount}</td>
                                        <td className="text-right" style={{ fontWeight: 'bold',color:'black' }}>{row.Rate}</td>
                                        <td className="text-center" style={{ fontWeight: 'bold',color:'black' }}>{row.Mode == 'K' ? 'Lagaai' : row.Mode == 'L' ? 'Khai' : row.Mode}</td>
                                        <td className="text-center" style={{ fontWeight: 'bold',color:'black' }}>{row.Run}</td>
                                        <td style={{color:'black'}}>{formatDateWithDashes(row.DT)} {new Date(row.DT).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true }).toUpperCase()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Exposure;
